<!-- 页面内容 -->
<!-- About us -->
<template>
    <!-- container -->
    <div class='content'>
        <div class="container cont nav">

            <div class="contV">
                <span style="color: #8FA2B2;cursor: pointer;" @click="goTT">News</span> > Details
                <!-- <div class="T1">All Brands</div> -->
                <div class="topA">
                    <div class="leftV">
                        <div class="T1" style="cursor: pointer;" @click="previewAllGood">All Brands</div>
                        <div class="lines"></div>
                        <div style="cursor: pointer;" :class="idx == index ? 'ppv1' : 'ppv'"
                            v-for="(item, index) in List" :key="index" @click="goTab(index, item.brandId)">
                            <img class="p1" :src="item.logo" alt="" />
                            <span class="p2">{{ item.name }}</span>
                        </div>
                    </div>
                    <div v-loading="loading" style="margin-left: 32px;">
                        <good-list :columnNum="4" :width1="1160" :goodList="FlashList" v-if="FlashList.length > 0" />

                        <!-- 分页组件 -->
                        <el-pagination @current-change="handlePageChange" :current-page="currentPage"
                            :page-size="pageSize" layout="prev, pager, next" :total="total">

                        </el-pagination>
                    </div>
                </div>

            </div>



        </div>
    </div>
</template>

<script>
import GoodList from '@/components/GoodList/GoodList.vue'
export default {
    components: { GoodList },
    data() {
        return {
            ids: '',
            idx: 0,
            loading: false,
            List: [],
            FlashList: [],
            jumpPage: 1,
            currentPage: 1, // 当前页码  
            pageSize: 20, // 每页显示的数据条数  
            total: 0, // 总数据条数  
            goodsList: [], // 所有商品数据  
            currentGoods: [] // 当前页显示的商品数据  
        }
    },
    mounted() {
        this.ids = this.$route.query.ids;
        this.idx = this.$route.query.idx;
        console.warn(this.$route.query.ids, "this.$route.query.ids")
        console.warn(this.$route.query.idx, "this.$route.query.idx")
        this.getAboutApi();


    },
    methods: {
        handleJump() {
            this.currentPage = this.jumpPage;
        },
        previewAllGood() {
            this.ids = undefined;
            this.idx = -1;
            this.listFlashApi("")
        },
        goTT() {
            this.$router.push({
                path: "Brands"
            })
        },
        goTab(index, id) {
            this.idx = index;
            this.ids = id;
            // console.warn(e)
            this.listFlashApi(id)
        },
        // 处理分页改变  
        handlePageChange(page) {
            this.currentPage = page;
            this.listFlashApi();
        },
        // 根据当前页码更新当前页显示的商品数据  
        updateCurrentGoods() {
            const start = (this.currentPage - 1) * this.pageSize;
            const end = this.currentPage * this.pageSize;
            this.currentGoods = this.goodsList.slice(start, end);
        },
        // 品牌下的商品
        async listFlashApi() {
            this.loading = true;
            try {
                const res = await this.$get('system/goods/list', {
                    brandId: this.ids,
                    pageNum: this.currentPage,
                    pageSize: this.pageSize
                });
                this.total = res.total;
                console.warn(res, "esssss")
                this.loading = false;
                this.FlashList = this.goodListAttrFormat(res.rows || []);
            } catch (error) {
            }
        },
        // 查询品牌 
        async getAboutApi() {
            try {
                const res = await this.$get('system/brand/list');
                this.List = res.rows || [];
                this.listFlashApi()
                console.warn(res, "查询品牌")
            } catch (error) {
            }
        },
        goForm() {
            console.warn('+++++++++')
            this.$router.push({
                path: "customizationFrom"
            })
        },

    },
}
</script>

<style lang='scss' scoped>
@import './index1.scss';

::v-deep .el-pagination {
    padding: 25px 5px !important;
    text-align: center !important;
}
</style>